import { render } from "./transactionManagements.vue?vue&type=template&id=8d4ec470&scoped=true"
import script from "./transactionManagements.vue?vue&type=script&lang=js"
export * from "./transactionManagements.vue?vue&type=script&lang=js"

import "./transactionManagements.vue?vue&type=style&index=0&id=8d4ec470&lang=scss&scoped=true"
import "./transactionManagements.vue?vue&type=style&index=1&id=8d4ec470&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d4ec470"]])

export default __exports__